@if (config) {
<div class="course-list">
  <qa-grid-data [config]="config">
    <qa-no-entity-info noContent [listInfo]="listInfo"></qa-no-entity-info>
  </qa-grid-data>
</div>
}
